import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root',
})
export abstract class StorageService {
  protected localStorageKey: string;

  constructor(
    protected storage: Storage
  ){
    this.initStorage();
  }

  private async initStorage() {
    await this.storage.create();
  }

  async getItem() {    
    return await this.storage.get(this.localStorageKey);
  }

  setitem<T>(value: T) {
    return this.storage.set(this.localStorageKey, value);
  }

  removeItem<T>() {
    return this.storage.remove(this.localStorageKey);
  }

  clear() {
    return this.storage.clear();
  }

  async removeUserToken() {
    await this.storage.remove('auth_token');
  }

  async getAuthToken() {
    return await this.storage.get(this.localStorageKey);;
  }

  async clearCart() {
    await this.storage.remove('cart');
  }
}
